// client/src/components/shell/PfAppDrawer.js
import { useEffect } from 'react';
import { NavLink, useNavigate, Link } from 'react-router-dom';
import { Scrawl } from '../mischief/Scrawl';

export function PfAppDrawer({ open, onClose, onSignOut, teamContext = null }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  const handleSignOut = async () => {
    onClose();
    if (onSignOut) {
      await onSignOut();
    } else {
      navigate('/');
    }
  };

  return (
    <>
      <div
        onClick={onClose}
        className={`
          fixed inset-0 z-40 bg-ink/40
          transition-opacity duration-200
          ${open ? 'opacity-100' : 'opacity-0 pointer-events-none'}
        `}
        aria-hidden
      />

      <aside
        className={`
          fixed left-0 top-0 bottom-0 z-50
          w-[80vw] max-w-[320px]
          bg-white shadow-xl
          flex flex-col
          transition-transform duration-200 ease-out
          ${open ? 'translate-x-0' : '-translate-x-full'}
        `}
        role="dialog"
        aria-modal="true"
        aria-label="Menu"
      >
        <div className="px-6 pt-8 pb-4 border-b border-ink/10">
          <div className="font-serif text-2xl text-ink">Menu</div>
          <Scrawl rotate={-2} color="inkSub" size="sm">
            where to?
          </Scrawl>
        </div>

        {/* Team context section — only shown when inside a team.
            Surfaces the current team and the "Switch Team" escape hatch
            so mobile users don't get stranded inside a team's chrome. */}
        {teamContext && (
          <div className="px-6 py-4 border-b border-ink/10 bg-ink/[0.02]">
            <div className="text-xs uppercase tracking-wide text-ink-sub mb-1">
              Current team
            </div>
            <div className="font-serif text-lg text-ink mb-3 truncate">
              {teamContext.name}
            </div>
            <Link
              to="/teams"
              onClick={onClose}
              className="
                inline-flex items-center gap-1
                text-sm font-medium text-accent
                hover:underline
              "
            >
              ← Switch team
            </Link>
          </div>
        )}

        <nav className="flex-1 px-3 py-3 flex flex-col gap-1">
          <DrawerLink to="/" onClick={onClose} end>Home</DrawerLink>
          <DrawerLink to="/teams" onClick={onClose}>Teams</DrawerLink>
          <DrawerLink to="/whoami" onClick={onClose}>Who am I? (dev)</DrawerLink>
        </nav>

        <div className="border-t border-ink/10 px-3 py-3">
          <button
            type="button"
            onClick={handleSignOut}
            className="
              w-full text-left px-3 py-3
              rounded-lg
              text-ink-sub hover:text-ink hover:bg-ink/5
              transition-colors
            "
          >
            Sign out
          </button>
        </div>
      </aside>
    </>
  );
}

function DrawerLink({ to, children, onClick, end }) {
  return (
    <NavLink
      to={to}
      end={end}
      onClick={onClick}
      className={({ isActive }) => `
        px-3 py-3 rounded-lg
        font-serif text-lg
        transition-colors
        ${isActive
          ? 'bg-highlight/40 text-ink'
          : 'text-ink-sub hover:text-ink hover:bg-ink/5'}
      `}
    >
      {children}
    </NavLink>
  );
}